import {
  Box,
  Button,
  CssBaseline,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import moment from 'moment'
import React, { createRef, useEffect, useRef, useState } from 'react'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import BodyMapCanvas from '../../../../../components/Canvas/BodyMapCanvas'

//Images
import adultFrontImage from '../../../../../assets/images/bodyMaps/AdultFront.jpg'
import Konva from 'konva'
import API from '../../../../../services/API'
import getMedicalDrawingCanvas from './getMedicalDrawingCanvas'

const BodyMaps = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })
  const [backgroundImageFile, setBackgroundImageFile] =
    useState(adultFrontImage)
  const [selectedImage, setSelectedImage] = useState('Adult Front')
  const [drawMarks, setDrawMarks] = useState([])
  const [color, setColor] = useState('#F26419')
  const stageRef = useRef(null)
  const [image, setImage] = useState(null)

  useEffect(() => {
    setBackgroundImageFile(getMedicalDrawingCanvas(selectedImage))
  }, [selectedImage])

  const handleSaveClick = async () => {
    const stage = stageRef.current

    const tempLayer = new Konva.Layer()

    if (image) {
      const img = new Konva.Image({
        image,
        width: stage.width(),
        height: stage.height(),
      })
      tempLayer.add(img)
    }

    drawMarks.forEach((line) => {
      const lineShape = new Konva.Line({
        points: line.points,
        stroke: line.color,
        strokeWidth: 5,
        tension: 0.5,
      })
      tempLayer.add(lineShape)
    })

    stage.add(tempLayer)
    tempLayer.draw()

    const dataURL = stage.toDataURL()

    tempLayer.destroy()

    console.log('Saved Data URL with Background:', dataURL)

    const dataURLtoFile = (dataURL, filename) => {
      const arr = dataURL.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }

    // Usage
    const file = dataURLtoFile(dataURL, 'image.png')

    // const localURL = URL.createObjectURL(dataURL)
    await API.post('gets3uploadUrl', {
      folder: 'epcr/medicaldrawings',
      extension: 'png',
    }).then((res) => {
      API.put(res.data.url, file, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(() => {
        submitModule(`Drawing - ${selectedImage}`, {
          dateTime: moduleValues.dateTime,
          Notes: moduleValues.Notes,
          awsMedicalDrawing: res.data.key,
        })
      })
    })
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={8}>
        <Typography variant="title2">Body Maps</Typography>
      </Grid>
      <Grid item xs={12} lg={4}>
        <AnDateTimePicker
          date={moduleValues.dateTime}
          fullWidth
          size="small"
          onChange={(newDate) =>
            setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
          }
        />
      </Grid>
      <Grid item xs={12} lg={8}>
        <BodyMapCanvas
          drawMarks={drawMarks}
          setDrawMarks={setDrawMarks}
          color={color}
          backgroundImageFile={backgroundImageFile}
          stageRef={stageRef}
          image={image}
          setImage={setImage}
        />
      </Grid>
      <Grid
        item
        xs={12}
        lg={4}
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        gap={1}
      >
        <Button
          fullWidth
          color="anRed"
          variant="outlined"
          onClick={() => setDrawMarks([])}
        >
          Clear
        </Button>
        <FormControl fullWidth>
          <InputLabel>Image</InputLabel>
          <Select
            value={selectedImage}
            onChange={(e) => setSelectedImage(e.target.value)}
            label="image"
          >
            {[
              'Adult Front',
              'Adult Back',
              'Baby Back',
              'Baby Front',
              'Baby Left',
              'Baby Right',
              'Child Back',
              'Child Front',
              'Ear Left',
              'Ear Right',
              'Face',
              'Foot Left',
              'Foot Right',
              'Hand Left',
              'Hand Right',
              'Head Front',
              'Head Left',
              'Head Right',
              'Head Top',
            ].map((x) => (
              <MenuItem key={x} value={x}>
                {x}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Stack direction="row" gap={1}>
          <TextField
            type="color"
            label="Colour"
            value={color}
            onChange={(e) => setColor(e.target.value)}
            sx={{ flex: 1 }}
          />
        </Stack>
        <TextField
          value={moduleValues?.Notes ?? ''}
          onChange={(e) =>
            setModuleValues((prev) => ({ ...prev, Notes: e.target.value }))
          }
          multiline
          minRows={2}
          label="Notes"
        />
        <Button
          onClick={handleSaveClick}
          fullWidth
          color="success"
          variant="contained"
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}

export default BodyMaps
